<template>
	<div class="node-accordion">
		<div
			class="node-accordion-header d-flex align-items-center"
			@click="toggle"
			@mouseenter="onMouseEnter"
			@mouseleave="onMouseLeave"
			:style="setHeaderStyle()">
			<div class="node-accordion-left-icon"
				:class="{
					'invisible': !showArrow
				}"
				:style="`margin-right: ${iconSpacing}px`"
				v-if="arrowPosition === 'left'">
				<div>
					<i :class="isOpen ? iconActive : icon" />
				</div>
			</div>
			<slot name="heading" />
			<template v-if="showArrow && arrowPosition === 'right'">
				<div class="ml-auto">
					<i :class="isOpen ? iconActive : icon" />
				</div>
			</template>
		</div>
		<!-- v-show="isOpen" -->
		<!-- <div
			class="node-accordion-body"
			:class="{
				'show': isOpen,
			}"
			:style="[
				contentStyle,
				setHeightOnOpen(),
			]"
			@mouseenter="onMouseEnter"
			@mouseleave="onMouseLeave"
			@click="onBodyClick">
			<slot
				name="body"
			/>
		</div> -->
		<transition
			name="accordion"
			v-on:before-enter="beforeEnter"
			v-on:enter="enter"
			v-on:before-leave="beforeLeave"
			v-on:leave="leave">
			<div
				class="node-accordion-body"
				v-show="isOpen"
				:style="contentStyle">
				<slot name="body"/>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Accordion',
	props: {
		title: {
			type: String,
			default: '',
		},
		showArrow: {
			type: Boolean,
			default: true,
		},
		arrowPosition: {
			type: String,
			default: 'right',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		autoClose: {
			type: Boolean,
			default: false,
		},
		openFirst: {
			type: Boolean,
			default: false,
		},
		icon: String,
		iconActive: String,
		headerStyle: Object,
		headerActiveStyle: Object,
		contentStyle: Object,
		iconSpacing: [Number, String],
	},
	data() {
		return {
			isOpen: false,
			isOverElement: false,
		};
	},
	watch: {
		openFirst(open) {
			this.isOpen = open;
		},
	},
	mounted() {
		if (this.openFirst) {
			this.isOpen = true;
		}
	},
	methods: {
		toggle() {
			if (!this.disabled) {
				this.isOpen = !this.isOpen;
				this.$emit('toggle-click', this.isOpen);
			}
		},
		handleClick() {
			if (this.autoClose && !this.isOverElement && this.isOpen) {
				this.isOpen = !this.isOpen;
			}
		},
		onMouseEnter() {
			this.isOverElement = true;
		},
		onMouseLeave() {
			this.isOverElement = false;
		},
		onBodyClick() {
			this.isOverElement = true;
		},
		setHeaderStyle() {
			const style = this.isOpen
				? this.headerActiveStyle
				: this.headerStyle;
			return style;
		},
		setHeightOnOpen() {
			const style = {};
			if (this.isOpen) {
				style.display = 'flex';
				style.height = '100%';
			} else {
				style.display = 'none';
				style.height = 0;
			}
			return style;
		},

		beforeEnter(el) {
			el.style.height = '0';
		},
		enter(el) {
			el.style.height = `${el.scrollHeight}px`;
		},
		beforeLeave(el) {
			el.style.height = `${el.scrollHeight}px`;
		},
		leave(el) {
			el.style.height = '0';
		},
	},
	created() {
		window.addEventListener('click', this.handleClick);
	},
	destroyed() {
		window.removeEventListener('click', this.handleClick);
	},
};
</script>

<style lang="scss" scoped>
.node-accordion {
	position: relative;
	width: 100%;
	margin-top: -1px;
	// background: ;
	// border-top: 1px solid #ddd;
	// border-bottom: 0;
	// border-right: 1px solid #ddd;
	// border-left: 1px solid #ddd;
}

.node-accordion-header {
	padding: 10px;
	cursor: pointer;
}

.node-accordion-body {
	// display: none;
	margin-top: -1px;
	padding: 10px;
	border-bottom: 1px solid #C8C8C8;

	overflow: hidden;
	transition: 150ms ease-out;

	&.show {
		display: flex;
		// height: 100%;
		// transition: height 200ms;
	}
}

.node-accordion-left-icon {
	opacity: 1;

	i {
		margin-bottom: 4px;
	}

	&.invisible {
		opacity: .5;
	}
}

.collapse:not(.show) {
	display: none;
}

.collapsing {
	position: relative;
	height: 0;
	overflow: hidden;
	transition: height 0.35s ease;
}


</style>
